import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, ExternalLink } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLanguage, getPageTexts } from '../i18n/pageTranslations';

const MapaSitio = () => {
  const lang = useLanguage();
  const t = getPageTexts('mapaSitio', lang);
  
  const estructura = [
    {
      categoria: "Página Principal",
      items: [
        { nombre: "Inicio", url: "/", descripcion: "Página principal del sitio" },
        { nombre: "Contacto", url: "/contacto", descripcion: "Formulario de contacto general" },
      ]
    },
    {
      categoria: "El Doctor",
      items: [
        { nombre: "El Dr. Norro", url: "/el-doctor", descripcion: "Biografía, filosofía y trayectoria" },
        { nombre: "Acreditaciones", url: "/el-doctor/acreditaciones", descripcion: "Certificaciones y credenciales" },
      ]
    },
    {
      categoria: "Cirugía Facial",
      items: [
        { nombre: "Hub Cirugía Facial", url: "/cirugia-facial", descripcion: "Vista general de cirugía facial" },
        { nombre: "Blefaroplastia", url: "/blefaroplastia", descripcion: "Cirugía de párpados" },
        { nombre: "Lifting Facial y Cervical", url: "/lifting-facial", descripcion: "Rejuvenecimiento facial quirúrgico" },
        { nombre: "Rinoplastia", url: "/rinoplastia", descripcion: "Cirugía de nariz" },
        { nombre: "Otoplastia", url: "/otoplastia", descripcion: "Corrección de orejas" },
        { nombre: "Ojeras y Bolsas", url: "/ojeras-bolsas", descripcion: "Tratamiento quirúrgico de ojeras" },
      ]
    },
    {
      categoria: "Cirugía Corporal",
      items: [
        { nombre: "Hub Cirugía Corporal", url: "/cirugia-corporal", descripcion: "Vista general de cirugía corporal" },
        { nombre: "Cirugía de Mamas", url: "/cirugia-mamas", descripcion: "Aumento, reducción y elevación" },
        { nombre: "Ginecomastia", url: "/ginecomastia", descripcion: "Reducción de mama masculina" },
        { nombre: "Abdominoplastia", url: "/abdominoplastia", descripcion: "Cirugía de abdomen" },
        { nombre: "Cirugía Postbariátrica", url: "/cirugia-postbariatrica", descripcion: "Cirugía tras pérdida de peso" },
        { nombre: "Liposucción-Lipoescultura", url: "/liposuccion", descripcion: "Eliminación de grasa localizada" },
        { nombre: "Ginecología Estética", url: "/gineco-estetica", descripcion: "Con Dra. Susana Varela" },
      ]
    },
    {
      categoria: "Medicina Estética y Bienestar",
      items: [
        { nombre: "Hub Medicina Estética", url: "/medicina-estetica", descripcion: "Vista general de tratamientos" },
        { nombre: "Rinomodelación®", url: "/rinomodelacion", descripcion: "Corrección nasal sin cirugía" },
        { nombre: "Endolifting Láser", url: "/endolifting", descripcion: "Rejuvenecimiento mínimamente invasivo" },
        { nombre: "Eliminación de Papada", url: "/papada", descripcion: "Tratamiento del doble mentón" },
        { nombre: "Elevación de Cejas", url: "/elevacion-cejas", descripcion: "Lifting de cejas sin cirugía" },
        { nombre: "Armonización Facial", url: "/armonizacion-facial", descripcion: "Fillers y neuromoduladores" },
        { nombre: "Ojeras sin Cirugía", url: "/ojeras-sin-cirugia", descripcion: "Tratamiento no quirúrgico" },
        { nombre: "Medicina Integrativa", url: "/medicina-integrativa", descripcion: "Bienestar y salud integral" },
      ]
    },
    {
      categoria: "Cirugía Reparadora y Pericial",
      items: [
        { nombre: "Hub Cirugía Reparadora", url: "/cirugia-reparadora", descripcion: "Vista general" },
        { nombre: "Cirugía Dermatológica", url: "/cirugia-dermatologica", descripcion: "Cirugía de la piel" },
        { nombre: "Cirugía Plástica Secundaria", url: "/cirugias-secundarias", descripcion: "Revisiones y correcciones" },
        { nombre: "Segunda Opinión", url: "/segunda-opinion", descripcion: "Consulta de segunda opinión" },
        { nombre: "Peritación Médica", url: "/peritacion-medica", descripcion: "Valoración del daño corporal" },
      ]
    },
    {
      categoria: "Rinomodelación® (Subpáginas)",
      items: [
        { nombre: "¿Qué es?", url: "/rinomodelacion/que-es", descripcion: "Información sobre el procedimiento" },
        { nombre: "Técnica y Materiales", url: "/rinomodelacion/tecnica-materiales", descripcion: "Detalles técnicos" },
        { nombre: "Resultados", url: "/rinomodelacion/resultados", descripcion: "Galería de casos" },
        { nombre: "El Doctor", url: "/rinomodelacion/doctor", descripcion: "Especialista en rinomodelación" },
        { nombre: "Preguntas Frecuentes", url: "/rinomodelacion/faq", descripcion: "FAQ del tratamiento" },
        { nombre: "Contacto", url: "/rinomodelacion/contacto", descripcion: "Solicitar consulta" },
      ]
    },
    {
      categoria: "Clínica y Ubicaciones",
      items: [
        { nombre: "Donde le Atendemos", url: "/donde-atendemos", descripcion: "Ubicaciones y hospitales" },
        { nombre: "Clínica Alameda", url: "/clinica-alameda", descripcion: "Clínica principal en Marbella" },
      ]
    },
    {
      categoria: "Guías y Recursos",
      items: [
        { nombre: "Guía Cuidados Blefaroplastia", url: "/guia-cuidados-blefaroplastia", descripcion: "Cuidados pre y postoperatorios" },
      ]
    },
    {
      categoria: "Áreas Privadas",
      items: [
        { nombre: "Portal Clínicas", url: "/portal-clinicas", descripcion: "Acceso para clínicas colaboradoras" },
        { nombre: "CRM Admin", url: "/crm", descripcion: "Panel de administración" },
      ]
    },
  ];

  return (
    <div className="min-h-screen bg-ivory">
      <Header />
      
      {/* Hero */}
      <section className="pt-12 pb-16 bg-cream">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="text-center">
            <p className="eyebrow mb-4">Estructura del Sitio</p>
            <h1 className="font-serif text-4xl md:text-5xl text-charcoal mb-6">
              Mapa de Navegación
            </h1>
            <div className="w-16 h-px bg-gold mx-auto mb-6"></div>
            <p className="text-text-secondary max-w-2xl mx-auto">
              Estructura completa de todas las páginas y secciones del sitio web del Dr. Ángel Norro.
            </p>
          </div>
        </div>
      </section>

      {/* Sitemap Content */}
      <section className="py-16 bg-ivory">
        <div className="container mx-auto px-6 max-w-5xl">
          <div className="grid gap-10">
            {estructura.map((seccion, idx) => (
              <div key={idx} className="border border-divider p-8 bg-ivory">
                <h2 className="font-serif text-2xl text-charcoal mb-6 flex items-center gap-3">
                  <span className="w-8 h-8 bg-gold text-ivory flex items-center justify-center text-sm font-sans">
                    {idx + 1}
                  </span>
                  {seccion.categoria}
                </h2>
                
                <div className="grid gap-3">
                  {seccion.items.map((item, itemIdx) => (
                    <div 
                      key={itemIdx}
                      className={`flex items-center justify-between p-4 border transition-all ${
                        item.pendiente 
                          ? 'border-divider bg-cream/50' 
                          : 'border-divider hover:border-gold hover:bg-cream'
                      }`}
                    >
                      <div className="flex items-center gap-4">
                        <ChevronRight size={16} className="text-gold" />
                        <div>
                          <div className="flex items-center gap-2">
                            {item.pendiente ? (
                              <span className="text-text-muted">{item.nombre}</span>
                            ) : (
                              <Link 
                                to={item.url}
                                className="text-charcoal hover:text-gold transition-colors font-medium"
                              >
                                {item.nombre}
                              </Link>
                            )}
                            {item.pendiente && (
                              <span className="text-[10px] tracking-wider uppercase bg-gold/20 text-gold px-2 py-0.5">
                                Pendiente
                              </span>
                            )}
                          </div>
                          <p className="text-text-muted text-sm">{item.descripcion}</p>
                        </div>
                      </div>
                      
                      <div className="text-text-muted text-xs font-mono">
                        {item.url}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Summary Stats */}
          <div className="mt-16 p-8 bg-charcoal">
            <h3 className="font-serif text-2xl text-ivory mb-8 text-center">
              Resumen de Estructura
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-center">
              <div>
                <p className="font-serif text-4xl text-gold mb-2">10</p>
                <p className="text-gold-light/70 text-sm">Categorías</p>
              </div>
              <div>
                <p className="font-serif text-4xl text-gold mb-2">42</p>
                <p className="text-gold-light/70 text-sm">Páginas Activas</p>
              </div>
              <div>
                <p className="font-serif text-4xl text-gold mb-2">5</p>
                <p className="text-gold-light/70 text-sm">Menús Principales</p>
              </div>
            </div>
          </div>

          {/* Navigation Menu Structure */}
          <div className="mt-16">
            <h3 className="font-serif text-2xl text-charcoal mb-8 text-center">
              Estructura del Menú Principal
            </h3>
            
            <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
              {[
                {
                  menu: "Cirugía Facial",
                  items: ["Blefaroplastia", "Lifting Facial y Cervical", "Rinoplastia", "Otoplastia"]
                },
                {
                  menu: "Cirugía Corporal",
                  items: ["Cirugía de Mamas", "Ginecomastia", "Abdominoplastia", "Cirugía Postbariátrica", "Liposucción", "Ginecología Estética"]
                },
                {
                  menu: "Medicina Estética",
                  items: ["Rinomodelación®", "Endolifting Láser", "Eliminación de Papada", "Elevación de Cejas", "Armonización Facial", "Ojeras sin Cirugía", "Medicina Integrativa"]
                },
                {
                  menu: "Cirugía Reparadora",
                  items: ["Cirugía Dermatológica", "Cirugía Plástica Secundaria", "Segunda Opinión", "Peritación Médica"]
                },
                {
                  menu: "El Dr. Norro",
                  items: ["Biografía", "Filosofía", "Marcas Registradas", "Metasigna", "Clínica", "Acreditaciones"]
                }
              ].map((menuItem, idx) => (
                <div key={idx} className="border border-divider p-6">
                  <p className="eyebrow text-gold mb-4">{menuItem.menu}</p>
                  <ul className="space-y-2">
                    {menuItem.items.map((item, itemIdx) => (
                      <li key={itemIdx} className="text-text-secondary text-sm flex items-center gap-2">
                        <span className="w-1 h-1 bg-gold"></span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MapaSitio;
